import { jsx as _jsx } from "react/jsx-runtime";
import { useBrandUrl } from "@/hooks";
import { useMapContext } from "@/domains/map";
import { useI18n } from "@/shared/hooks";
import { useBreakpointValue } from "@gemini/core";
import { useLocation } from "@/location/hooks/useLocation";
import { CellContentCustom } from "@/components/CellContentCustom/CellContentCustom";
import { useCdpNavigate } from "@/app/router";
import { CLIENT_ROUTES } from "@/app/router/constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode/useIsPreviewMode";
export const MapTravelTimeEntry = () => {
    const { t } = useI18n();
    const placeholderUrl = useBrandUrl({
        endpoint: "/shared/images/map/travel-time.png",
    });
    const isMobile = useBreakpointValue({
        base: true,
        lg: false,
    });
    const navigate = useCdpNavigate();
    const { setIsSidebarOpen } = useMapContext();
    // @ts-ignore
    const { isGeoDataDefined } = useLocation();
    const isPreviewMode = useIsPreviewMode();
    const handleOpen = () => {
        if (isPreviewMode)
            return;
        if (isMobile) {
            setIsSidebarOpen(true);
        }
        navigate(CLIENT_ROUTES.MAP);
    };
    if (!isGeoDataDefined)
        return null;
    return (_jsx(CellContentCustom, { title: t("location.map.travel_times.title"), description: t("hardfacts.travel_times_entry.description"), placeholderStart: {
            alt: t("location.map.travel_times.title"),
            url: placeholderUrl,
        }, onPress: handleOpen, isClickDisabled: isPreviewMode }));
};
